import { createSlice } from "@reduxjs/toolkit";

export const globalSlice = createSlice({
  name: "global",
  initialState: {
    isOnline: true,
    offlineTimer: 0,
    maxTimeOffline: 5 * 60,
    user: null,
    simplifyMode: false,
  },
  reducers: {
    setIsOnline: (state, action) => {
      state.isOnline = action.payload;
    },
    setOfflineTimer: (state, action) => {
      state.offlineTimer = action.payload;
    },
    resetOfflineTimer: (state) => {
      state.offlineTimer = 0;
    },
    increaseOfflineTimer: (state) => {
      state.offlineTimer += 1;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
    logoutUser: (state) => {
      state.user = null;
    },
    toggleSimplifyMode: (state) => {
      state.simplifyMode = !state.simplifyMode;
    },
    setSimplifyMode: (state, action) => {
      state.simplifyMode = action.payload;
    },
  },
});

export const {
  setUser,
  logoutUser,
  setIsOnline,
  setOfflineTimer,
  resetOfflineTimer,
  increaseOfflineTimer,
  toggleSimplifyMode,
  setSimplifyMode,
} = globalSlice.actions;

export default globalSlice.reducer;
